import { DecoratorNode } from 'lexical';

import Spinner from 'shopper/components/Spinner';

class SkeletonNode extends DecoratorNode {
  __src;
  __height;
  __width;

  constructor(key) {
    super(key);
  }

  static clone({ key } = {}) {
    return new SkeletonNode(key);
  }

  static getType() {
    return 'skeleton';
  }

  static importDOM() {
    return null;
  }

  static importJSON(serializedNode) {
    return $createSkeletonNode(serializedNode);
  }

  createDOM() {
    return document.createElement('div');
  }

  exportDOM() {
    return { element: null };
  }

  updateDOM() {
    return false;
  }

  exportJSON() {
    return {
      type: 'skeleton',
    };
  }

  decorate() {
    return (
      <div className="relative min-h-6 w-fit min-w-24">
        <div className="absolute left-1/2 top-1/2 z-1">
          <Spinner className="size-8" />
        </div>
      </div>
    );
  }
}

export const $createSkeletonNode = ({ key } = { key: null }) =>
  new SkeletonNode(key);

export const $isSkeletonNode = (node) => node instanceof SkeletonNode;

export const $addSkeletonNodeConfig = (nodes) => {
  nodes.push(SkeletonNode);
};

export default SkeletonNode;
